import { z } from "zod";

const ScorePointSchema = z.object({
    point: z.number(),
    count: z.number()
});

const DistributionWithheldReasons = ["below-minimum-cohort"] as const;

export const ScoreDistributionSchema = z.object({
    average: z.number().nullable(),
    contributingCount: z.number(),
    totalRevieweeCount: z.number(),
    points: z.array(ScorePointSchema),
    withheldReason: z.enum(DistributionWithheldReasons).optional()
});
export type ScoreDistribution = z.infer<typeof ScoreDistributionSchema>;
